import { rem } from '@app/utils/sx/functions';
import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

export const heading: SxProps<Theme> = {
  maxWidth: rem(415),
  mt: { xs: rem(40), md: rem(188) },
  mb: rem(32),
};

export const button: SxProps<Theme> = {
  '&.MuiButton-outlinedPrimary:hover': {
    borderColor: 'primary.main',
  },
};

export const buttonGroup: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
  gap: { xs: rem(16), md: rem(24) },
  mb: rem(32),
};

export const phoneNumber: SxProps<Theme> = {
  whiteSpace: 'nowrap',
};

export const hint: SxProps<Theme> = {
  mb: rem(32),
  color: 'text.auxiliary',
  fontSize: rem(14),
  lineHeight: rem(24),
};

export const emailButton: SxProps<Theme> = {
  '.MuiButton-startIcon': {
    mr: rem(5),
  },
};
